import { useDispatch } from 'react-redux'
import { InputSwitch } from 'primereact/inputswitch'
import { useAppSelector } from '../../../../../stateManagement/hooks/redux'
import { setPathsListIsGroupedByRaions } from '../../../../../stateManagement/reducers'
import { getItemWebStorage, setItemWebStorage } from '../../../../../features/webStorageSaver'

export default function GroupByRaionsSwitcher() {
    const dispatch = useDispatch()
    const pathsListIsGroupedByRaions = useAppSelector(state => state.pathsInfo.pathsListIsGroupedByRaions);

    function switchGroupByRaions(value) {
        dispatch(setPathsListIsGroupedByRaions(value))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, pathsListIsGroupedByRaions: value }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }

    return (
        <div className='raion-group-switcher-div'>
            <label htmlFor="groupByRaionFlag">Группировка по районам</label>
            <InputSwitch checked={pathsListIsGroupedByRaions} inputId="groupByRaionFlag" onChange={(e) => switchGroupByRaions(e.value)} />
        </div>
    )
}
